export default "__VITE_ASSET__Dhh16ab6__"